import React from 'react';
import { TabGroup } from '../../components/common';
import SignUpForm from '../../components/forms/SignUpForm';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../lib/routes';

const SignUpPage = () => {
  const navigate = useNavigate();

  return (
    <div className='lg:max-h-screen overflow-y-auto scrollbar-hide flex flex-col w-full max-w-[27.5rem] mx-auto lg:py-12 py-8'>
      <h2 className='h3 !font-medium mb-1 text-secondary-500 lg:text-left text-center'>
        Sign up and let your AI bring the right people to you.
      </h2>
      <p className='text-sm mb-6 lg:text-left text-center'>
        Join in and start discovering meaningful matches made just for you.
      </p>

      <TabGroup
        tabs={[
          { label: 'Login', value: 'login' },
          { label: 'Signup', value: 'signup' },
        ]}
        activeTab='signup'
        onChange={tab => navigate(routes[tab as keyof typeof routes])}
        tabSize='md'
      />

      <SignUpForm />
    </div>
  );
};

export default SignUpPage;
